import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private darkModeKey = 'darkMode'; // Key to store the dark mode in localStorage
  private tokenKey = 'authToken'; // Key to store the token in localStorage
  private loginUrl = `${environment.apiUrl}/Authentication/Token`; // Your backend login URL
  private username = '';
  public usernameChanged = new EventEmitter<string>();

  constructor(private http: HttpClient) {
    console.log("Auth servcie created!!!");
    if (localStorage.getItem(this.darkModeKey) == 'true') {
      this.toggleDarkMode(true);
    } else {
      this.toggleDarkMode(false);
    }
  }

  // Login method to get the JWT token
  login(username: string, password: string): Observable<any> {
    return this.http.post<any>(this.loginUrl, { username, password }).pipe(
      tap(response => this.setToken(response.token)) // Assuming the token is in the 'token' field of the response
    );
  }

  toggleDarkMode(darkMode?: boolean): void {
    const element = document.querySelector('html');
    if (element === null) {
      return;
    }

    if (darkMode == null) {
      darkMode = !element.classList.contains('my-app-dark');
    }

    if (darkMode) {
      element.classList.add('my-app-dark');
    } else {
      element.classList.remove('my-app-dark');
    }

    localStorage.setItem(this.darkModeKey, darkMode ? 'true' : 'false');
  }

  // Set the token in localStorage
  private setToken(token: string): void {
    localStorage.setItem(this.tokenKey, token);
    this.parseJwt();
    this.usernameChanged.emit(this.username);
  }

  // Get the token from localStorage
  getToken(): string | null {
    return localStorage.getItem(this.tokenKey);
  }

  // Check if the user is logged in
  isLoggedIn(): boolean {
    return !!this.getToken(); // Returns true if the token exists
  }

  getUsername(): string {
    if (!this.isLoggedIn()) {
      return '';
    }

    if (this.username == null || this.username == '') {
      this.parseJwt();
    }

    return this.username;
  }

  hasRoles(roles: string[] | null): boolean {
    if (roles == null || roles.length == 0) {
      return true;
    }

    for (const role of roles) {
      if (this.hasRole(role)) {
        return true;
      }
    }

    return false;
  }

  hasRole(role: string): boolean {
    if (!this.isLoggedIn()) {
      return false;
    }

    switch (role) {
      case 'CampaignManager':
        return this.username.toLocaleLowerCase().includes('admin');
      case 'DealManager':
        return this.username.toLocaleLowerCase().includes('admin');
      case 'AccountingManager':
        return this.username.toLocaleLowerCase().includes('accountingdpt');
    }

    return true;
  }

  // Logout method
  logout(): void {
    this.username = '';
    localStorage.removeItem(this.tokenKey);
    this.usernameChanged.emit(this.username);
  }

  private parseJwt() {
    const token = this.getToken();

    if (token == "" || token == null) {
      return;
    }

    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    const parsed = JSON.parse(jsonPayload);

    this.username = parsed.unique_name;
  }
}